import { Listbox } from "@headlessui/react";
import classNames from "classnames";
import constants from "../../utils/constants";

const DropdownTag = ({ label, options, onChange, selectedOptions, labelMappings }) => {
  const isSelected = options.reduce(
    (init, opt) => selectedOptions.indexOf(opt) > -1 || init,
    false
  );

  return (
    <Listbox
      as={"div"}
      value={selectedOptions}
      onChange={(values) => onChange(values)}
      multiple
      className="relative"
    >
      <Listbox.Button
        className={classNames(
          "relative border border-gray-600 ui-open:border-gray-200 dark:ui-open:border-gray-400 rounded-full bg-transparent ui-open:bg-gray-200 dark:ui-open:bg-transparent flex items-center pl-5 pr-2",
          {
            "!bg-teal-400 !text-gray-100 !border-teal-400": isSelected,
          }
        )}
      >
        <span className="sm:text-[12px] truncate">{labelMappings[label]}</span>
        <span className="ml-3 flex items-center">
          <svg
            width="1"
            height="20"
            viewBox="0 0 1 20"
            fill="currentColor"
            stroke="currentColor"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect width="1" height="20" fill="" />
          </svg>

          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M8 10L12 14L16 10"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </span>
      </Listbox.Button>
      <Listbox.Options
        className={
          "absolute top-full left-1/2 -translate-x-1/2 mt-1 z-10 py-3 px-2 space-y-2 bg-gray-200 dark:bg-gray-800 rounded-6 overflow-hidden max-h-[200px] overflow-y-auto scrollbar-light min-w-max text-[12px]"
        }
      >
        {options.map((opt) => (
          <Listbox.Option
            key={opt}
            value={opt}
            as={"div"}
            className="cursor-pointer hover:bg-gray-200 dark:hover:bg-gray-800 px-3"
          >
            <div className="flex items-center space-x-3">
              <span className="flex items-center">
                <svg
                  className="hidden ui-selected:inline-block"
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M3 1C1.89688 1 1 1.89688 1 3V13C1 14.1031 1.89688 15 3 15H13C14.1031 15 15 14.1031 15 13V3C15 1.89688 14.1031 1 13 1H3ZM11.5313 6.53125L7.53125 10.5312C7.2375 10.825 6.7625 10.825 6.47188 10.5312L4.47188 8.53125C4.17813 8.2375 4.17813 7.7625 4.47188 7.47188C4.76563 7.18125 5.24063 7.17813 5.53125 7.47188L7 8.94063L10.4688 5.46875C10.7625 5.175 11.2375 5.175 11.5281 5.46875C11.8188 5.7625 11.8219 6.2375 11.5281 6.52813L11.5313 6.53125Z"
                    fill="#00A9A7"
                  />
                  <path
                    d="M11.5313 6.53125L7.53125 10.5312C7.2375 10.825 6.7625 10.825 6.47188 10.5312L4.47188 8.53125C4.17813 8.2375 4.17813 7.7625 4.47188 7.47188C4.76563 7.18125 5.24063 7.17813 5.53125 7.47188L7 8.94063L10.4688 5.46875C10.7625 5.175 11.2375 5.175 11.5281 5.46875C11.8188 5.7625 11.8219 6.2375 11.5281 6.52813L11.5313 6.53125Z"
                    fill="#0C1723"
                  />
                </svg>
                <svg
                  className="inline-block ui-selected:hidden"
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M1 3C1 1.89531 1.89531 1 3 1H13C14.1031 1 15 1.89531 15 3V13C15 14.1031 14.1031 15 13 15H3C1.89531 15 1 14.1031 1 13V3ZM2.5 3V13C2.5 13.275 2.72375 13.5 3 13.5H13C13.275 13.5 13.5 13.275 13.5 13V3C13.5 2.72375 13.275 2.5 13 2.5H3C2.72375 2.5 2.5 2.72375 2.5 3Z"
                    fill="#9EA3A8"
                  />
                </svg>
              </span>

              <span>{labelMappings[opt]}</span>
            </div>
          </Listbox.Option>
        ))}
      </Listbox.Options>
    </Listbox>
  );
};

export default DropdownTag;
